// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3UvmQ","label":"Completed_label__FuTMd"};